import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import AppSlice from '../slices/AppSlice'
import AuthSlice from '../slices/AuthSlice'
import NotificationSlice from '../slices/NotificationSlice'
import VisitsSlice from '../slices/VisitsSlice'
import OrderSlice from '../slices/OrdersSlice'
import BeneficiarySlice from '../slices/BeneficiarySlice'
import StaffSlice from '../slices/StaffSlice'
import CounterSlice from '../slices/CounterSlice'
import BedManagementSlice from '../slices/BedManagementSlice'
import WardManagementSlice from '../slices/WardManagementSlice'
import WriteOffSlice from '../slices/WriteOffSlice'
import QueueManagementSlice from '../slices/QueueManagementSlice'
import { baseApi } from '../api/baseApi'

const persistConfig = {
  key: 'root-his-v3',
  storage,
  blacklist: [baseApi.reducerPath],
  migrate: (state) => {
    if (!state) return Promise.resolve(state);
    const rest = { ...state };
    delete rest[baseApi.reducerPath];
    return Promise.resolve(rest);
  },
}

const allReducers = combineReducers({
  app: AppSlice,
  auth: AuthSlice,
  visits: VisitsSlice,
  orders: OrderSlice,
  beneficiary: BeneficiarySlice,
  staff: StaffSlice,
  counter: CounterSlice,
  bedManagement: BedManagementSlice,
  wardManagement: WardManagementSlice,
  writeOff: WriteOffSlice,
  queueManagement: QueueManagementSlice,
  notification: NotificationSlice,
  [baseApi.reducerPath]: baseApi.reducer,
})

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined
  }
  return allReducers(state, action)
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
})

const persistor = persistStore(store)

export { store, persistor }
